import React, { useState } from "react";
import { isValidRegex } from "@sscs/utils";
import { Button } from "..";
import styles from "./stringValue.module.scss";
const StringValue = ({ value, regex }) => {
    const [showAll, setShowAll] = useState(false);
    const data = [];
    const sizeLimit = 100;
    let previous = 0;
    let highlight = false;
    if (!value)
        return React.createElement("span", null, value);
    if (regex && isValidRegex(regex)) {
        const matches = value.matchAll(new RegExp(regex, "ig"));
        for (const match of matches) {
            if (match.index !== undefined) {
                if (showAll || match.index + match[0].length <= sizeLimit) {
                    data.push(JSON.stringify(value.substring(previous, match.index)).slice(1, -1));
                    data.push(React.createElement("span", { key: previous, className: styles.highlight }, JSON.stringify(match[0]).slice(1, -1)));
                    previous = match.index + match[0].length;
                }
                else if (match.index + match[0].length > sizeLimit) {
                    highlight = true;
                }
            }
        }
    }
    if (previous < value.length) {
        if (showAll) {
            data.push(JSON.stringify(value.substring(previous)).slice(1, -1));
        }
        else {
            if (value.length <= sizeLimit) {
                data.push(JSON.stringify(value.substring(previous)).slice(1, -1));
            }
            else {
                data.push(JSON.stringify(value.substring(previous, sizeLimit)).slice(1, -1));
                data.push("...");
            }
        }
    }
    if (value.length > sizeLimit)
        data.push(React.createElement(Button, { variant: "text", isInline: true, key: "button", onClick: () => setShowAll(!showAll), className: `${styles.button} ${highlight && !showAll ? styles.highlight : ""}` },
            "Show ",
            showAll ? "less" : "more"));
    return React.createElement(React.Fragment, null, data);
};
export default StringValue;
//# sourceMappingURL=StringValue.js.map